import './slider.sss';
import { S, SA } from '../../Utilities';
import { wrapper, navigation } from './templates.templ';

export default class Slider  {

  constructor(el, customclasses = '', els = 'li', options) {
    this.el = S(el);
    this.els = els;
    this.list = [];
    this.slideEls = SA(els, S(el));
    this.index = 0;
    this.customclasses = customclasses;
    this.options = Object.assign({
      dotts: false,
      arrowNav: true,
      legend: true,
      timer: false
    }, options);
    this.render();
    this.arrows = {
      left: this.el.querySelector('.arrows_left'),
      right: this.el.querySelector('.arrows_right')
    };
    
    if (this.options.timer) {
      this.startTimer();
    } else {
      this.changeSlide();
    }
    return this.el;
  }

  onClick(e, i) {
    clearInterval(this.timer);
    this.index = i;
    this.changeSlide();
  }

  startTimer() {
    this.timer = setInterval(()=> {
      this.index = this.index > this.list.length - 2 ? 0 : this.index + 1;
      this.changeSlide();
    }, 5000);
  }

  onArrow(e, type) {
    clearInterval(this.timer);
    if (type === 'left') {
      this.index = this.index < 1 ? this.list.length - 1 : this.index - 1;
    } else {
      this.index = this.index > this.list.length - 2 ? 0 : this.index + 1;
    }
    this.changeSlide();
  }

  setToActive(li, i) {
    
    li.className = li.className.replace(/\sactive/g, '');
    

    if (i === this.index) {
      var cl = li.className.split(' ');
      cl.push('active');
      li.className = cl.join(' ');
      const newIndex = this.index > this.list.length - 2 ? 0 : this.index + 1;

      this.arrows.right.style.backgroundImage = this.slideEls[newIndex].style.backgroundImage;
    }
  }

  changeSlide() {
    const { dotts, legend } = this.options;
    const sliders = this.el.querySelectorAll(`.slider_comp ${this.els}`);
    var i = 0;

      

    if (dotts) {
      let i = 0;
      const navList = this.el.querySelectorAll('.slider_nav_widget_list li');
      while(i < navList.length) {
        this.setToActive(navList[i], i);
        i += 1;
      }
    }

    i = 0;
    while(i < sliders.length) {
      this.setToActive(sliders[i], i);
      i += 1;
    }
  }

  render() {
    wrapper(this);
    const nav = navigation(this, this.els);
    if (!nav) {
      return;
    }
    const { slider, slides } = nav;
    this.el = slider;
    this.list = slides;
  }
}
